module.exports = __webpack_public_path__ + "img/xiangshui(7).19332fff.png";